import Vue from 'vue';
import VueCookies from 'vue-cookies'

window.axios = require('axios');
window.qs = require('qs');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': token.content,
        },
    });
} else {
    console.error('CSRF token not found!');
}


Vue.use(VueCookies);
